import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row align-items-center"
}
const _hoisted_2 = { class: "col-xl-6 text-center position-relative" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "col-xl-6 text-center text-xl-start" }
const _hoisted_5 = { class: "subscription-name mb-1" }
const _hoisted_6 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" For: ")
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = { class: "mb-1" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Status: ")
const _hoisted_11 = { class: "row g-0 product-actions" }
const _hoisted_12 = { class: "col-lg btn-group ps-lg-0" }
const _hoisted_13 = {
  key: 0,
  class: "btn w-100 h-100 p-0 rounded-bottom font-weight-bold bg-secondary d-flex justify-content-around border-0"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Manage Subscription ")
const _hoisted_15 = {
  key: 0,
  class: "w-50 gray-button-background rounded-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_subscription_status = _resolveComponent("subscription-status")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cancel_subscription_button = _resolveComponent("cancel-subscription-button")!
  const _component_content_card = _resolveComponent("content-card")!

  return (_openBlock(), _createBlock(_component_content_card, {
    "use-default-theme": true,
    class: "subscription-card d-flex flex-column justify-content-between mb-3 mb-lg-0"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (!_ctx.subscription.canReactivate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: {
                                name: _ctx.routeNames.subscription,
                                params: {
                                    subscriptionId: _ctx.subscription.id,
                                    type: _ctx.subscription.type
                                }
                            },
                  class: _normalizeClass('fs-6 font-weight-bold btn text-white mx-1 ' + (_ctx.showCancelButton ? 'w-50' : 'w-100'))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["to", "class"]),
                (_ctx.showCancelButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_cancel_subscription_button, {
                        subscription: _ctx.subscription,
                        "button-class": "fs-6 font-weight-bold btn text-black mx-1 gray-button-background ",
                        "show-icon": false,
                        onCancelSubscriptionClicked: _cache[0] || (_cache[0] = ($event: any) => (
                                    _ctx.$emit('cancelSubscriptionClicked', $event)
                                ))
                      }, null, 8, ["subscription"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.subscription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.subscription.imageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.subscription.imageUrl,
                    class: "img-fluid subscription-logo",
                    alt: `${_ctx.subscription.name} Product Image`
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.subscription.name), 1),
              (_ctx.subscription.customerName)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.subscription.customerName), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_subscription_status, {
                  status: _ctx.subscription.status
                }, null, 8, ["status"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}